import React from 'react';

import { prepareInput, splitInputsByRenderBlock, mergeInputs } from '../../../Input';

import { companyFormInputs } from './companyFormInputs';

class CompanyForm extends React.Component {
  constructor(props) {
    super(props);
    const { currentCompany = {}, user = {} } = props;

    this.state = {
      companyName: currentCompany.COMPANY_NAME ?? user?.company ?? '',
      inn: currentCompany.INN ?? '',
      kpp: currentCompany.KPP ?? '',
      city: currentCompany.CITY ?? '',
      cityCode: currentCompany.CITY_CODE ?? '',
      paymentAccount: currentCompany.BANK_ACCOUNT ?? '',
      paymentCorAccount: currentCompany.CORR_ACCOUNT ?? '',
      bankBik: currentCompany.BIK ?? '',
      bankName: currentCompany.BANK ?? '',
      address: currentCompany.LEGAL_ADDRESS ?? '',
      factAddress: currentCompany.LOCATION_ADDRESS ?? '',
      inputs: companyFormInputs,
    };
  }

  changeInput = (name, val, dadataValue = null) => {
    const newState = this.state;
    newState[name] = val;
    
    if (dadataValue && dadataValue.typeOfEntity === 'company') {
      newState.companyName = dadataValue.value;
      newState.inn = dadataValue.data.inn;
      newState.kpp = dadataValue.data.kpp;
      newState.city = dadataValue.data.address.data.city;
      newState.cityCode = dadataValue.data.address.data.city_kladr_id;
      newState.address = dadataValue.data.address.unrestricted_value;
      newState.factAddress = dadataValue.data.address.unrestricted_value;
    }
    if (dadataValue && dadataValue.typeOfEntity === 'bank') {
      newState.bankBik = dadataValue.data.bic;
      newState.bankName = dadataValue.value;
      newState.paymentCorAccount = dadataValue.data.correspondent_account;
    }

    if (dadataValue && dadataValue.typeOfEntity === 'city') {
      newState.cityCode = dadataValue.city_kladr_id;
    }

    this.setState(newState);
  };

  getData = () => {
    const data = { ...this.state };
    delete data.inputs;
    return data;
  };

  validateInput = name => {
    const { inputs } = this.state;
    const currentInputIndex = inputs.findIndex(input => input.name === name);
    const currentInput = inputs[currentInputIndex];
    const isValid = currentInput.validator(this.state[currentInput.name]);
    if (!isValid !== currentInput.error) {
      const newInputs = inputs.slice(0);
      newInputs[currentInputIndex] = { ...currentInput, error: !isValid };
      this.setState({ inputs: newInputs });
    }
  };

  validateForm = () => {
    const { inputs } = this.state;
    const newInputs = inputs.slice(0);

    let isValidationPassed = true;
    newInputs.forEach((input, index) => {
      const isValid = input.validator(this.state[input.name]);
      isValidationPassed = isValidationPassed && isValid;
      if (!isValid !== input.error) {
        newInputs[index] = { ...input, error: !isValid };
      }
    });

    this.setState({ inputs: newInputs });
    return isValidationPassed;
  };

  static defaultProps = {
    disabledInputs: [],
    isFormDisabled: false,
  };

  render() {
    const { inputs } = this.state;
    const { disabledInputs, isFormDisabled } = this.props;

    const mergedInputs = mergeInputs(inputs, disabledInputs);
    const splittedInputs = splitInputsByRenderBlock(mergedInputs);

    return (
      <div className="registration__form">
        {splittedInputs.map((block) => (
          <div className="inp-wrap" key={block[0].name}>
            {block?.map(input =>
              prepareInput({
                ...input,
                disabled: input.disabled || isFormDisabled,
                value: this.state[input.name],
                onChangeCallback: this.changeInput,
                onBlurCallback: this.validateInput,
              }),
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default CompanyForm;